/*!
 * Api, uses Axios Promise based HTTP client for the browser and node.js
 * Authors: ['Jorge Brunal Perez (aka Diniremix)', 'Duverney Ortiz']
 * Version: 2020-04-23
 * https://git.sitimapa.co/openroute/openroute-admin
 * Released under the MIT License.
 */

import axios from "axios";
import * as constants from "@/constants";
import store from "@/store";
import router from "@/router";
import User from "@/models/User.js";

const defaultResposeError = (error) => {
	// Standarize errors.
	let errorMessage = null;

	if (error.response) {
		errorMessage = error.response.statusText || error.response.status;
	} else if (error.request) {
		errorMessage = "no response from server";
	} else {
		errorMessage = error.message;
	}
	return new Promise((resolve, reject) => {
		reject(new Error(errorMessage));
	});
};

//Add a request interceptor
axios.interceptors.request.use(
	(config) => {
		// Do something before request is sent
		// if (store.state.setLogin.access_token !== null) {
		// 'Authorization': 'Bearer ' + store.state.setLogin.access_token,
		const elToken = JSON.parse(window.localStorage.getItem("userInfo"));
		const userInfo = JSON.parse(localStorage.userInfo);
		if (elToken !== null) {
			config.headers = {
				...config.headers,
				Authorization: `Bearer ${userInfo.access_token}`,
			};
			return config;
		}
		return config;
	},
	(error) => {
		// Do something with request error
		return Promise.reject(error);
	}
);

const checkSessionExist = (resposeError) => {
	try {
		if (resposeError.response) {
			if (
				resposeError.response.data.error === "The server could not verify that a session exists." ||
				resposeError.response.data.message === "you don't have permission to access the requested resource"
			) {
				localStorage.removeItem("accessToken");
				localStorage.removeItem("userInfo");
				const user = new User();
				user.deleteUserIndexed().then((res) => {
					return res;
				});
				router.push({path: "/pages/login", query: {reload: true}}).catch(() => {});
			}
		}
	} catch (error) {
		console.error(error);
	}
};
export default {
	get(url) {
		return axios
			.get(constants.API_BASE_URL + url)
			.then(
				(response) =>
					new Promise((resolve) => {
						resolve(response.data);
					})
			)
			.catch(
				(defaultResposeError) =>
					new Promise((resolve, reject) => {
						if (defaultResposeError.hasOwnProperty("response")) {
							if (defaultResposeError.response.data.status === 722) {
								store.commit("setRequiredPermissions", defaultResposeError.response.data);
							}
							checkSessionExist(defaultResposeError);
							reject(defaultResposeError.response.data || {error: "error"});
						} else {
							checkSessionExist(defaultResposeError);
						}
					})
			);
	},

	post(url, data = {}) {
		return axios
			.post(constants.API_BASE_URL + url, data)
			.then(
				(response) =>
					new Promise((resolve) => {
						resolve(response.data);
					})
			)
			.catch(
				(defaultResposeError) =>
					new Promise((resolve, reject) => {
						if (defaultResposeError.hasOwnProperty("response")) {
							if (defaultResposeError.response.data.status === 722) {
								store.commit("setRequiredPermissions", defaultResposeError.response.data);
							}
							checkSessionExist(defaultResposeError);
							reject(defaultResposeError.response.data);
						} else {
							checkSessionExist(defaultResposeError);
						}
					})
			);
	},

	put(url, data = {}) {
		return axios
			.put(constants.API_BASE_URL + url, data)
			.then(
				(response) =>
					new Promise((resolve) => {
						resolve(response.data);
					})
			)
			.catch(
				(defaultResposeError) =>
					new Promise((resolve, reject) => {
						if (defaultResposeError.hasOwnProperty("response")) {
							if (defaultResposeError.response.data.status === 722) {
								store.commit("setRequiredPermissions", defaultResposeError.response.data);
							}
							checkSessionExist(defaultResposeError);
							reject(defaultResposeError.response.data);
						} else {
							checkSessionExist(defaultResposeError);
						}
					})
			);
	},

	delete(url) {
		return axios
			.delete(constants.API_BASE_URL + url)
			.then(
				(response) =>
					new Promise((resolve) => {
						resolve(response.data);
					})
			)
			.catch(
				(defaultResposeError) =>
					new Promise((resolve, reject) => {
						if (defaultResposeError.hasOwnProperty("response")) {
							if (defaultResposeError.response.data.status === 722) {
								store.commit("setRequiredPermissions", defaultResposeError.response.data);
							}
							checkSessionExist(defaultResposeError);
							reject(defaultResposeError.response.data);
						} else {
							checkSessionExist(defaultResposeError);
						}
					})
			);
	},
	upload(url, formData) {
		const config = {
			onUploadProgress: function (progressEvent) {
				let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
				store.commit("uploadFile/incrementProgress", percentCompleted);
			},
		};
		return axios
			.post(constants.API_BASE_URL + url, formData, config, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.then(
				(response) =>
					new Promise((resolve) => {
						resolve(response.data);
					})
			)
			.catch(defaultResposeError);
	},
};
